import { css } from '@/styled-system/css';

export const cardShell = css({
  '--map-info-card-bg': '{colors.bg.neutral}',
  isolation: 'isolate',
  pointerEvents: 'auto',
  position: 'relative',
});

export const cardArrow = css({
  borderBottomColor: 'transparent',
  borderBottomWidth: 'none',
  borderLeftColor: 'transparent',
  borderLeftWidth: '{spacing.default}',
  borderRightColor: 'transparent',
  borderRightWidth: '{spacing.default}',
  borderStyle: 'solid',
  borderTopColor: 'var(--map-info-card-bg)',
  borderTopWidth: '{spacing.350}',
  bottom: '-350',
  height: 'zero',
  left: 'var(--map-overlay-anchor-x, 50%)',
  pointerEvents: 'none',
  position: 'absolute',
  transform: 'translateX(-50%)',
  width: 'zero',
  zIndex: 'zIndexStepOver',
  "[data-map-overlay-placement='below'] &": {
    borderBottomColor: 'var(--map-info-card-bg)',
    borderBottomWidth: '{spacing.350}',
    borderTopColor: 'transparent',
    borderTopWidth: 'none',
    bottom: 'auto',
    top: '-350',
  },
});

export const cardContainer = css({
  position: 'relative',
  background: 'var(--map-info-card-bg)',
  color: 'text.neutral',
  borderRadius: 'md',
  overflow: 'hidden',
  padding: 'tighter',
  boxShadow: 'md',
  pointerEvents: 'auto',
  zIndex: 'zIndexStep',
});

export const closeButton = css({
  position: 'absolute',
  top: 'tightest',
  left: 'tightest',
  zIndex: 'zIndexStepOver',
});
